module.exports = __webpack_public_path__ + "static/media/shanghai-0-prototype.00d52923.gif";